<template>
  <div>
    <div v-if="loaded" class="w-100">
      <b-row>
        <b-col cols="6"></b-col>
        <b-col class="d-flex justify-content-end" cols="6">
          <h-b-action
            :positive="false"
            icon="mdi mdi-cog"
            text="Gérer le tableau de bord"
            @click.native="activeFilter = !activeFilter"
          ></h-b-action>
        </b-col>
      </b-row>
      <grid-layout
        :col-num="12"
        :is-draggable="true"
        :is-mirrored="false"
        :is-resizable="true"
        :layout.sync="actualLayout"
        :margin="[10, 10]"
        :responsive="true"
        :responsive-layouts="layout"
        :row-height="55"
        :vertical-compact="true"
        @breakpoint-changed="breakpointChangedEvent"
      >
        <grid-item
          v-for="item in actualLayout"
          :key="item.i"
          :h="item.h"
          :i="item.i"
          :w="item.w"
          :x="item.x"
          :y="item.y"
          @moved="onLayoutUpdated"
          @resized="onLayoutUpdated"
        >
          <h-e-recap
            v-if="dashboards[item.i].type === 'numbers'"
            :color="dashboards[item.i].color"
            :label="dashboards[item.i].label"
            :number="String(dashboards[item.i].functions.number.number)"
            :total="`${String(dashboards[item.i].functions.total.number)}${dashboards[item.i].functions.total.unit}`"
            white
          ></h-e-recap>
          <b-card v-if="dashboards[item.i].type === 'array'" class="p-1 pb-2 h-100 w-100 overflow-auto">
            <b-row>
              <h5>
                {{ dashboards[item.i].label }}
              </h5>
            </b-row>
            <h-t-table style="max-height: 100%" class="sm">
              <template #table-head>
                <h-t-table-header v-for="header in dashboards[item.i].headers" :key="header" tiny>
                  {{ header }}
                </h-t-table-header>
              </template>
              <template #table-body>
                <tr v-for="data in dashboards[item.i].datas" :key="data.id">
                  <h-t-table-element
                    v-for="lookup_field in dashboards[item.i].lookup_fields"
                    :key="lookup_field[0]"
                    tiny
                  >
                    {{ formatPrint(data, lookup_field) }}
                  </h-t-table-element>
                </tr>
              </template>
            </h-t-table>
          </b-card>
          <h-w-recap
            v-if="dashboards[item.i].type === 'recap'"
            :headers="dashboards[item.i].headers"
            :title="dashboards[item.i].label"
          >
            <template v-for="(category, key, index) in dashboards[item.i].categories" #[index]>
              <div :key="key">
                <h-b-colorful
                  v-for="(output_function, keyy) in category.functions"
                  :key="keyy"
                  :color="category.color"
                  :legend="output_function.unit"
                  :number="output_function.number"
                  class="mb-3"
                ></h-b-colorful>
              </div>
            </template>
          </h-w-recap>
        </grid-item>
      </grid-layout>
      <h-f-slider v-if="loaded" v-model="activeFilter" :footer="false" title="Gérer le tableau de bord">
        <div v-for="dashboard in layout.filters" :key="dashboard.label">
          <label>
            {{ dashboard.label }}
          </label>
          <div>
            <b-form-checkbox
              v-for="filter in dashboard.filters"
              :key="filter.label"
              v-model="filter.value"
              class="mb-2"
            >
              {{ filter.label }}
            </b-form-checkbox>
          </div>
        </div>
      </h-f-slider>
    </div>
    <div v-else>
      <vue-content-loading :width="1920" height="300" class="mb-5" v-for="i in 2" :key="i">
        <rect x="5" y="200" rx="0" ry="0" width="530" height="100" />
        <rect x="5" y="5" rx="0" ry="0" width="530" height="180" />
        <rect x="550" y="5" rx="0" ry="0" width="530" height="180" />
        <rect x="550" y="200" rx="0" ry="0" width="530" height="100" />
        <rect x="1095" y="5" rx="0" ry="0" width="530" height="180" />
        <rect x="1095" y="200" rx="0" ry="0" width="530" height="100" />
        <rect x="1640" y="5" rx="0" ry="0" width="300" height="300" />
      </vue-content-loading>
    </div>
  </div>
</template>
<script>
import VueGridLayout from 'vue-grid-layout'
import VueContentLoading from 'vue-content-loading'

import axios from 'axios'
import { APIRequest } from '@/node-sdk'

export default {
  name: 'crm-dashboard',

  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    VueContentLoading,
  },

  filters: {
    formatDate() {
      return 'test'
    },
  },

  props: {
    widget: {
      type: Object,
      required: true,
    },
    widgetField: {
      type: String,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    layoutRoute: {
      type: String,
      required: true,
    },
    ressource: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      responsiveLayouts: {},
      activeFilter: false,
      dashboards: [],
      typeDimensions: {
        numbers: {
          w: 2,
          h: 2,
        },
        array: {
          w: 4,
          h: 4,
        },
        recap: {
          w: 4,
          h: 4,
        },
      },
      layout: {
        filters: this.filters,
      },
      defaultLayout: {
        id: null,
        lg: [],
        sm: [],
        md: [],
        filters: this.filters,
      },
      cols: {
        lg: 12,
        md: 10,
        sm: 8,
      },
      loaded: false,
      actualLayout: [],
      actualBreakPoint: 'lg',
    }
  },

  watch: {
    'layout.filters': {
      deep: true,
      async handler() {
        if (this.loaded) {
          await this.getDashboards()
          await this.$nextTick()
          this.formatGrid()
          await this.onLayoutUpdated()
        }
      },
    },
  },

  async mounted() {
    this.layout = this.widget[this.widgetField]
    if (!this.layout) {
      this.defaultLayout.widget = this.widget.id
      this.layout = await APIRequest.create(
        process.env.VUE_APP_DASHBOARD_API,
        `${this.layoutRoute}/own`,
        this.defaultLayout,
      )
    }
    // this.layout.sm = []
    // this.layout.md = []
    // this.layout.lg = []
    // this.layout.filters = this.filters
    // await APIRequest.create(process.env.VUE_APP_DASHBOARD_API, `${this.layoutRoute}/own`, this.layout)
    await this.getDashboards()
    this.actualLayout = []
    await this.$nextTick()
    this.loaded = true
  },

  methods: {
    async getDashboards() {
      const request = await this.formatRequest()
      this.dashboards = await axios.get(`${this.ressource}dashboard/${request}`)
      this.dashboards = this.dashboards.data
    },

    async formatRequest() {
      let request = ''
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const dashboardFiltersKey in this.layout.filters) {
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const filtersKey in this.layout.filters[dashboardFiltersKey].filters) {
          if (this.layout.filters[dashboardFiltersKey].filters[filtersKey].value) {
            if (request) {
              request = `${request}&${filtersKey}`
            } else {
              request = `?${filtersKey}`
            }
          }
          if (
            this.actualLayout.length &&
            this.actualLayout.find((layout) => layout.i === filtersKey) &&
            !this.layout.filters[dashboardFiltersKey].filters[filtersKey].value
          ) {
            this.$delete(
              this.layout.lg,
              this.layout.lg.findIndex((layout) => layout.i === filtersKey),
            )
            this.$delete(
              this.layout.sm,
              this.layout.sm.findIndex((layout) => layout.i === filtersKey),
            )
            this.$delete(
              this.layout.md,
              this.layout.md.findIndex((layout) => layout.i === filtersKey),
            )
            this.$delete(
              this.actualLayout,
              this.actualLayout.findIndex((layout) => layout.i === filtersKey),
            )
          }
        }
      }
      await APIRequest.create(process.env.VUE_APP_DASHBOARD_API, `${this.layoutRoute}/own`, this.layout)
      return request
    },

    async onLayoutUpdated() {
      if (this.loaded) {
        this.layout[this.actualBreakPoint] = JSON.parse(JSON.stringify(this.actualLayout))
        await APIRequest.create(process.env.VUE_APP_DASHBOARD_API, `${this.layoutRoute}/own`, this.layout)
      }
    },

    async breakpointChangedEvent(newBreakpoint) {
      await this.$nextTick()
      this.actualBreakPoint = newBreakpoint
      this.actualLayout = JSON.parse(JSON.stringify(this.layout[newBreakpoint]))
    },

    formatGrid() {
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const key in this.dashboards) {
        const newWidget = {
          x: (this.actualLayout.length * 2) % this.cols[this.actualBreakPoint],
          y: this.actualLayout.length + this.cols[this.actualBreakPoint], // puts it at the bottom
          w: this.typeDimensions[this.dashboards[key].type].w,
          h: this.typeDimensions[this.dashboards[key].type].h,
          i: key,
        }
        if (!this.actualLayout.find((layout) => layout.i === key)) {
          this.actualLayout.push(newWidget)
          this.layout.md.push(newWidget)
          this.layout.sm.push(newWidget)
          this.layout.lg.push(newWidget)
        }
      }
    },

    formatPrint(data, lookupField) {
      let result = JSON.parse(JSON.stringify(data))
      lookupField.forEach((field) => {
        result = result[field]
      })
      return result
    },
  },
}
</script>

<style scoped></style>
